<template>
  <div class="po">

    <!-- Hero -->
    <header class="po__hero">
      <div class="po__shell">
        <h1 class="po__hero-title">{{ $t('companyName') }}</h1>
        <p class="po__hero-sub">{{ $t('about.supprtInvest') }}</p>
        <div class="po__hero-actions">
          <button @click="goToContact" class="po__btn po__btn--primary">{{ $t('common.startInvest') }}</button>
          <button @click="goToContact" class="po__btn po__btn--outline">{{ $t('common.learnMore') }}</button>
        </div>
      </div>
    </header>

    <main class="po__main">
      <div class="po__shell">

        <!-- Products grid: 01 + 02 -->
        <div class="po__grid-2 po__section">

          <!-- 01 Cổ phiếu VN -->
          <div class="po__card">
            <div class="po__card-head">
              <span class="po__num">01</span>
              <div>
                <h2 class="po__card-title">{{ $t('about.partagerVN') }}</h2>
                <p class="po__card-sub">{{ $t('about.supportTVSI') }}</p>
              </div>
            </div>
            <ul class="po__list">
              <li><span class="po__dot"></span><p>{{ $t('about.supportTV') }} <strong>{{ $t('about.margin68') }}</strong></p></li>
              <li><span class="po__dot"></span><p>{{ $t('about.freeInvest') }}</p></li>
              <li><span class="po__dot"></span><p>{{ $t('about.masterInvest') }} <strong>{{ $t('about.more15y') }}</strong></p></li>
              <li><span class="po__dot"></span><p>{{ $t('about.adminSupport') }} <strong>5:1</strong>, {{ $t('about.realTime') }}</p></li>
            </ul>
          </div>

          <!-- 02 CFD -->
          <div class="po__card">
            <div class="po__card-head">
              <span class="po__num">02</span>
              <div>
                <h2 class="po__card-title">{{ $t('about.cfd') }}</h2>
                <p class="po__card-sub">{{ $t('about.extendInvest') }}</p>
              </div>
            </div>
            <div class="po__cfd-grid">
              <div class="po__cfd-item"><span>💱</span><p>{{ $t('about.forex') }}</p></div>
              <div class="po__cfd-item"><span>🏛️</span><p>{{ $t('about.product') }}</p></div>
              <div class="po__cfd-item"><span>📈</span><p>{{ $t('about.partagerNN') }}</p></div>
              <div class="po__cfd-item"><span>₿</span><p>{{ $t('about.crypto') }}</p></div>
            </div>
            <div class="po__backcom-note">
              <p class="po__backcom-note-title">🎯 {{ $t('about.backcomInvest') }}</p>
              <p class="po__backcom-note-sub">{{ $t('about.teamBackcome') }}</p>
            </div>
          </div>
        </div>

        <!-- 03 Copy Trade -->
        <div class="po__card po__card--dark po__section">
          <div class="po__card-head">
            <span class="po__num po__num--gold">03</span>
            <div>
              <h2 class="po__card-title po__card-title--light">{{ $t('about.copySystem') }}</h2>
              <p class="po__card-sub po__card-sub--light">{{ $t('about.winwin') }}</p>
            </div>
          </div>
          <div class="po__grid-2 po__grid-2--gap-sm">
            <div class="po__feature-card">
              <h3 class="po__feature-title">👥 {{ $t('about.forInvest') }}</h3>
              <ul class="po__feature-list">
                <li>• {{ $t('about.copyTrader') }}</li>
                <li>• {{ $t('about.automation') }}</li>
                <li>• {{ $t('about.outExp') }}</li>
                <li>• {{ $t('about.advanMaster') }}</li>
              </ul>
            </div>
            <div class="po__feature-card">
              <h3 class="po__feature-title">🏆 {{ $t('about.forMaster') }}</h3>
              <ul class="po__feature-list">
                <li>• {{ $t('about.receiveInvest') }}</li>
                <li>• {{ $t('about.createStrategy') }}</li>
                <li>• {{ $t('about.incomeFollower') }}</li>
                <li>• {{ $t('about.shareAndIncome') }}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 04 Partnership -->
        <div class="po__card po__section">
          <div class="po__card-head">
            <span class="po__num">04</span>
            <div>
              <h2 class="po__card-title">{{ $t('about.policyDevelop') }}</h2>
              <p class="po__card-sub">
                {{ $t('about.moreSys') }}
                <strong class="po__highlight--blue">{{ $t('about.more3000') }}</strong>
                {{ $t('common.and') }}
                <strong class="po__highlight--purple">{{ $t('about.more1200') }}</strong>
              </p>
            </div>
          </div>

          <div class="po__grid-2 po__grid-2--gap-lg">
            <!-- TVSI -->
            <div class="po__partner-card po__partner-card--tvsi">
              <div class="po__partner-logo"><span>TVSI</span></div>
              <h3 class="po__partner-title">📈 {{ $t('about.parnerTVSI') }}</h3>
              <div class="po__benefit">
                <div class="po__benefit-head">
                  <h4>💰 {{ $t('about.customerDevelop') }}</h4>
                  <div class="po__pct-wrap">
                    <div class="po__pct">39%</div>
                    <p>{{ $t('about.afterTax') }}</p>
                  </div>
                </div>
                <p>• {{ $t('about.backcomReal') }} <strong>50%</strong> {{ $t('about.fees') }}</p>
                <p>• {{ $t('about.afterFees') }} <strong>39%</strong> {{ $t('about.totalFees') }}</p>
              </div>
              <div class="po__benefit">
                <div class="po__benefit-head">
                  <h4>🤝 {{ $t('about.parnerDevelop') }}</h4>
                  <div class="po__pct-wrap">
                    <div class="po__pct">10%</div>
                    <p>{{ $t('about.totalIncome') }}</p>
                  </div>
                </div>
                <p>{{ $t('about.back') }} <strong>10%</strong> {{ $t('about.totalIncomeCTV') }}</p>
              </div>
            </div>

            <!-- Exness/CFD -->
            <div class="po__partner-card po__partner-card--exness">
              <div class="po__partner-logo po__partner-logo--wide"><span>{{ $t('about.cfd') }}</span></div>
              <h3 class="po__partner-title">🌍 {{ $t('about.cfd') }}</h3>
              <div class="po__benefit">
                <div class="po__benefit-head">
                  <h4>💰 {{ $t('about.customerDevelop') }}</h4>
                  <div class="po__pct-wrap">
                    <div class="po__pct">80%</div>
                    <p>{{ $t('about.spreadFees') }}</p>
                  </div>
                </div>
                <p>{{ $t('about.back') }} <strong>80%</strong> {{ $t('about.spreadFeesInvest') }}</p>
              </div>
              <div class="po__benefit">
                <div class="po__benefit-head">
                  <h4>🤝 {{ $t('about.parnerDevelop') }}</h4>
                  <div class="po__pct-wrap">
                    <div class="po__pct">10%</div>
                    <p>{{ $t('about.totalIncome') }}</p>
                  </div>
                </div>
                <p>{{ $t('about.back') }} <strong>10%</strong> {{ $t('about.totalIncomeParner') }}</p>
              </div>
            </div>
          </div>

          <!-- Note -->
          <div class="po__note">
            <div class="po__note-head">
              <span>💡</span>
              <h4>{{ $t('about.noteImportant') }}</h4>
            </div>
            <div class="po__grid-2 po__grid-2--gap-sm">
              <p><span class="po__dot po__dot--blue"></span>{{ $t('about.policyParner') }}</p>
              <p><span class="po__dot po__dot--purple"></span>{{ $t('about.incomeSys') }}</p>
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script src="./product-overview.js"></script>
<style src="./product-overview.scss" lang="scss"></style>
